<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="loading && !selectedLcData">
        <v-col cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-2">Loading...</p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header mb-4">
                LC Amendment Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="amendmentForm">
                  <v-row>
                    <!-- Left Column: LC Selection & Basic Info -->
                    <v-col md="4"  cols="12" >
                      <v-expansion-panels v-model="panel1" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header mb-4">LC Selection & Amendment Info</v-expansion-panel-title>
                          <v-expansion-panel-text>
                            <v-autocomplete
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="lc_id.value.value"
                              :items="getLcImportLcMasterList"
                              :item-title="item => `${item.lc_no} - ${item.code || ''}`"
                              item-value="id"
                              :error-messages="lc_id.errorMessage.value"
                              @update:modelValue="loadLcData"
                              clearable
                              :disabled="isEditMode"
                            >
                              <template #label>
                                Select LC <span class="text-red-accent-4">*</span>
                              </template>
                            </v-autocomplete>

                            <v-text-field
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_no.value.value"
                              :error-messages="amendment_no.errorMessage.value"
                              label="Amendment No"
                              required
                            ></v-text-field>

                          
                            <v-select
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_types.value.value"
                              :items="amendmentTypeOptions"
                              label="Amendment Types"
                              multiple
                              chips
                              clearable
                            >
                              <template #label>
                                Amendment Types
                              </template>
                            </v-select>

                            <v-text-field
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_charge.value.value"
                              :error-messages="amendment_charge.errorMessage.value"
                              label="Amendment Charge"
                              type="number"
                              prefix="৳"
                            ></v-text-field>


                            <v-date-input
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_date.value.value"
                              :error-messages="amendment_date.errorMessage.value"
                              label="Amendment Date"
                              prepend-icon=""
                              prepend-inner-icon="mdi-calendar"
                              required
                            ></v-date-input>

                            <v-textarea
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="remarks.value.value"
                              label="Remarks"
                              rows="3"
                            ></v-textarea>

                            <v-file-input
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="documents.value.value"
                              label="Upload Documents"
                              multiple
                              prepend-icon="mdi-paperclip"
                              show-size
                              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                            ></v-file-input>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>

                    <!-- Right Column: LC & PI Amendment Fields -->
                    <v-col md="8" cols="12">
                      <v-expansion-panels v-model="panel2" multiple>
                        <!-- LC Master Amendment -->
                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header mb-4">
                            LC Master Amendment
                          </v-expansion-panel-title>
                          <v-expansion-panel-text>
                            <v-row v-if="selectedLcData">
                              <v-col cols="12" md="6">
                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.supplier_id"
                                  :items="getSupplierList"
                                  :item-title="item => `${item.code} - ${item.name || item.supplier_name}`"
                                  item-value="id"
                                  label="Supplier"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.bank_id"
                                  :items="getLcBankList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Bank"
                                ></v-autocomplete>

                                <v-date-input
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.expiry_date"
                                  label="Expiry Date"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-date-input
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.last_shipment_date"
                                  label="Last Shipment Date"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-date-input
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.lc_open_date"
                                  label="LC Open Date"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.lc_amount"
                                  label="LC Amount"
                                  type="number"
                                  prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.margin_percent"
                                  label="Margin Percent (%)"
                                  type="number"
                                  suffix="%"
                                ></v-text-field>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.margin_amount"
                                  label="Margin Amount"
                                  type="number"
                                  prefix="৳"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" md="6">
                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.currency_id"
                                  :items="getCurrencyList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Currency"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.incoterm_id"
                                  :items="getLcIncotermList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Incoterm"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.payment_term_id"
                                  :items="getLcPaymentTermList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Payment Term"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.loading_port_id"
                                  :items="getLcPortList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Loading Port"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.discharge_port_id"
                                  :items="getLcPortList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Discharge Port"
                                ></v-autocomplete>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.shipping_method_id"
                                  :items="getLcShippingMethodList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="Shipping Method"
                                ></v-autocomplete>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.bank_charge"
                                  label="Bank Charge"
                                  type="number"
                                  prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.swift_charge"
                                  label="Swift Charge"
                                  type="number"
                                  prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.insurance"
                                  label="Insurance"
                                  type="number"
                                  prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.presentation_period"
                                  label="Presentation Period (Days)"
                                  type="number"
                                ></v-text-field>

                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  v-model="updates.value.value.lc_type_id"
                                  :items="getLcTypeList"
                                  :item-title="item => `${item.code} - ${item.name}`"
                                  item-value="id"
                                  label="LC Type"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-alert v-else type="info" density="compact" class="mt-2">
                              Please select an LC first
                            </v-alert>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>

                  </v-row>

                  <!-- Full Width: PI Amendment Sections -->
                  <v-row>
                    <v-col cols="12">
                      <v-expansion-panels v-model="panel3" multiple>
                        <!-- PI Items Amendment -->
                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header">
                            PI Items Amendment
                          </v-expansion-panel-title>
                          <v-expansion-panel-text>
                            <div v-if="selectedLcData && selectedLcData.pis && selectedLcData.pis.length > 0">
                              <div v-for="(pi, piIndex) in selectedLcData.pis" :key="`pi-${pi.id}-${pi.details?.length || 0}`" class="mb-4">
                                <v-card variant="outlined" class="mb-3">
                                  <v-card-title class="text-subtitle-1 bg-grey-lighten-4">
                                    PI: {{ pi.pi_no || pi.code }} - {{ formatDate(pi.pi_date) }}
                                  </v-card-title>
                                  <v-card-text>
                                    <v-data-table
                                      :key="`table-${pi.id}-${pi.details?.length || 0}`"
                                      :headers="piItemHeaders"
                                      :items="getPiItemsForAmendment(pi)"
                                      density="compact"
                                      class="elevation-0"
                                      :items-per-page="-1"
                                      hide-default-footer
                                    >
                                      <template v-slot:item.product="{ item }">
                                        <v-autocomplete
                                          v-if="item.isNew"
                                          v-model="item.product_id"
                                          :items="getMappedProductsForPi(pi)"
                                          :item-title="item => item && item.product ? `${item.product.name} - ${item.product.code}` : ''"
                                          item-value="product_id"
                                          density="compact"
                                          variant="outlined"
                                          hide-details
                                          @update:model-value="(val) => { item.product_id = val; selectProductForItem(pi.id, item, val); }"
                                        ></v-autocomplete>
                                        <span v-else>{{ item.product?.name || 'N/A' }}</span>
                                      </template>
                                      <template v-slot:item.qty="{ item }">
                                        <v-text-field
                                          v-model.number="item.qty"
                                          type="number"
                                          density="compact"
                                          variant="outlined"
                                          hide-details
                                          @update:model-value="() => updatePiItem(pi.id, item)"
                                          @blur="() => updatePiItem(pi.id, item)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:item.rate="{ item }">
                                        <v-text-field
                                          v-model.number="item.rate"
                                          type="number"
                                          density="compact"
                                          variant="outlined"
                                          hide-details
                                          @update:model-value="() => updatePiItem(pi.id, item)"
                                          @blur="() => updatePiItem(pi.id, item)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:item.amount="{ item }">
                                        {{ formatNumber(item.amount || ((parseFloat(item.qty) || 0) * (parseFloat(item.rate) || 0))) }}
                                      </template>
                                      <template v-slot:item.actions="{ item }">
                                        <v-btn
                                          icon="mdi-delete"
                                          size="small"
                                          variant="text"
                                          color="error"
                                          @click="removePiItem(pi.id, item)"
                                        ></v-btn>
                                      </template>
                                    </v-data-table>

                                    <v-btn
                                      class="mt-2"
                                      size="small"
                                      color="primary"
                                      prepend-icon="mdi-plus"
                                      @click="addNewPiItem(pi.id)"
                                    >
                                      Add Item
                                    </v-btn>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                            <v-alert v-else type="info" density="compact" class="mt-2">
                              No PI data available for the selected LC
                            </v-alert>
                          </v-expansion-panel-text>
                        </v-expansion-panel>

                        <!-- Add New PIs -->
                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header">
                            Add New PIs to LC
                          </v-expansion-panel-title>
                          <v-expansion-panel-text class="pt-4">
                            <v-autocomplete
                              v-if="selectedLcData"
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="new_pis.value.value"
                              :items="getAvailablePiList"
                              :item-title="(item) => `${item.pi_no} - ${item.code} (${formatDate(item.pi_date)}) - ${formatNumber(item.total_amount)})`"
                              item-value="id"
                              label="Select New Proforma Invoices (PI)"
                              multiple
                              chips
                              clearable
                              @update:model-value="loadNewPiDetails"
                            >
                              <template #label>
                                New Proforma Invoices (PI)
                              </template>
                            </v-autocomplete>
                            <v-alert v-else type="info" density="compact" class="mt-2">
                              Please select an LC first
                            </v-alert>

                            <!-- Display New PI Details -->
                            <div v-if="newPisDetails && newPisDetails.length > 0" class="mt-4">
                              <div v-for="(pi, piIndex) in newPisDetails" :key="`new-pi-${pi.id}`" class="mb-4">
                                <v-card variant="outlined" class="mb-3">
                                  <v-card-title class="text-subtitle-1 bg-blue-lighten-4">
                                    New PI: {{ pi.pi_no || pi.code }} - {{ formatDate(pi.pi_date) }}
                                    <v-chip color="success" size="small" class="ml-2">New</v-chip>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-row class="mb-2">
                                      <v-col cols="12" md="6">
                                        <strong>Supplier:</strong> {{ pi.supplier?.name || pi.supplier?.supplier_name || 'N/A' }}
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <strong>Total Amount:</strong> {{ formatNumber(pi.total_amount) }}
                                      </v-col>
                                    </v-row>
                                    <v-data-table
                                      :headers="piItemHeaders"
                                      :items="pi.details || []"
                                      density="compact"
                                      class="elevation-0"
                                      :items-per-page="-1"
                                      hide-default-footer
                                    >
                                      <template v-slot:item.product="{ item }">
                                        {{ item.product?.name || 'N/A' }}
                                      </template>
                                      <template v-slot:item.qty="{ item }">
                                        {{ formatNumber(item.qty) }}
                                      </template>
                                      <template v-slot:item.rate="{ item }">
                                        {{ formatNumber(item.rate) }}
                                      </template>
                                      <template v-slot:item.amount="{ item }">
                                        {{ formatNumber(item.amount || ((parseFloat(item.qty) || 0) * (parseFloat(item.rate) || 0))) }}
                                      </template>
                                    </v-data-table>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>

                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn
                        class="bg-red mr-2"
                        variant="flat"
                        @click="goBack"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        class="bg-brand"
                        variant="flat"
                        type="submit"
                        :loading="loading"
                      >
                        {{ isEditMode ? 'Update Amendment' : 'Save Amendment' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { toast } from 'vue3-toastify';
import formatDateView from '@/plugins/dateFormatView';
import formattedDate from '@/plugins/dateFormatter';

export default {
  name: 'LcImportLcAmendment',
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    
    const panel = ref([0]);
    const panel1 = ref([0]);
    const panel2 = ref([0]);
    const panel3 = ref([0]);
    const loading = ref(false);
    const selectedLcData = ref(null);
    const isEditMode = ref(false);
    const piItemChanges = ref({});
    const newPisDetails = ref([]);
    const loadingNewPis = ref(false);

    const amendmentTypeOptions = [
      'Expiry Change',
      'Qty Change',
      'Port Change',
      'PI Change',
      'Amount Change',
      'Date Change',
      'Other'
    ];

    const piItemHeaders = [
      { title: 'Product', key: 'product', sortable: false },
      { title: 'UOM', key: 'uom', sortable: false },
      { title: 'Quantity', key: 'qty', sortable: false, align: 'center' },
      { title: 'Rate', key: 'rate', sortable: false, align: 'center' },
      { title: 'Amount', key: 'amount', sortable: false, align: 'right' },
      { title: 'Actions', key: 'actions', sortable: false, width: '10%' },
    ];

    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        lc_id: yup.number().positive().integer().required().label('LC'),
        amendment_no: yup.string().required().label('Amendment No'),
        amendment_date: yup.date().required().label('Amendment Date'),
      }),
    });

    const lc_id = useField('lc_id');
    const amendment_no = useField('amendment_no', undefined, { initialValue: '' });
    const amendment_date = useField('amendment_date');
    const amendment_types = useField('amendment_types', undefined, { initialValue: [] });
    const amendment_charge = useField('amendment_charge', undefined, { initialValue: 0 });
    const remarks = useField('remarks', undefined, { initialValue: '' });
    const documents = useField('documents', undefined, { initialValue: [] });
    const updates = useField('updates', undefined, { initialValue: {} });
    const pi_item_updates = useField('pi_item_updates', undefined, { initialValue: [] });
    const new_pis = useField('new_pis', undefined, { initialValue: [] });

    const getLcImportLcMasterList = computed(() => {
      try {
        return store.getters.getLcImportLcMasterList || [];
      } catch (e) {
        return [];
      }
    });

    const getCurrencyList = computed(() => {
      try {
        return store.getters.getCurrencyList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcPortList = computed(() => {
      try {
        return store.getters.getLcPortList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcTypeList = computed(() => {
      try {
        return store.getters.getLcTypeList || [];
      } catch (e) {
        return [];
      }
    });

    const getSupplierList = computed(() => {
      try {
        return store.getters.getSupplierList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcBankList = computed(() => {
      try {
        return store.getters.getLcBankList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcIncotermList = computed(() => {
      try {
        return store.getters.getLcIncotermList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcPaymentTermList = computed(() => {
      try {
        return store.getters.getLcPaymentTermList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcShippingMethodList = computed(() => {
      try {
        return store.getters.getLcShippingMethodList || [];
      } catch (e) {
        return [];
      }
    });

    const getLcImportPiList = computed(() => {
      try {
        let pis = store.getters.getLcImportPiList || [];
        // Filter by branch_id and status (active PIs only)
        return pis.filter(
          (item) => item.branch_id == branchId.value && item.status == 1
        );
      } catch (e) {
        return [];
      }
    });

    // Get available PIs (exclude PIs already attached to the LC)
    const getAvailablePiList = computed(() => {
      if (!selectedLcData.value || !selectedLcData.value.pis) {
        return getLcImportPiList.value;
      }
      
      // Get IDs of PIs already attached to the LC
      const attachedPiIds = selectedLcData.value.pis.map(pi => pi.id);
      
      // Filter out already attached PIs
      return getLcImportPiList.value.filter(pi => !attachedPiIds.includes(pi.id));
    });

    const getProductList = computed(() => {
      try {
        return store.getters.getProductList || [];
      } catch (e) {
        return [];
      }
    });

    const branchId = computed(() => {
      try {
        return store.getters.getAuthUser?.branch_id || null;
      } catch (e) {
        return null;
      }
    });

    const getProductMapList = computed(() => {
      try {
        let products = store.getters.getProductMapList || [];
        // Filter by branch_id and status (active products only)
        return products.filter(
          (item) => item.branch_id == branchId.value && item.status == 1
        );
      } catch (e) {
        return [];
      }
    });

    // Get mapped products for PI - show all mapped products (not just ones in PI)
    // This allows adding any mapped product to the PI
    const getMappedProductsForPi = (pi) => {
      // Return all product maps (filtered by branch and status)
      // This allows users to add any mapped product to the PI
      return getProductMapList.value;
    };

    const loadLcData = async (lcId) => {
      if (!lcId) {
        selectedLcData.value = null;
        return;
      }

      try {
        loading.value = true;
        
        // Ensure product map list is loaded
        if (!store.getters.getProductMapList || store.getters.getProductMapList.length === 0) {
          await store.dispatch('getProductMapList', {});
        }
        
        const lcData = await store.dispatch('getLcImportLcMasterById', lcId);
        selectedLcData.value = lcData;
        
        // Initialize updates with current LC values - include ALL fields
        if (lcData) {
          updates.value.value = {
            expiry_date: lcData.expiry_date ? new Date(lcData.expiry_date) : null,
            last_shipment_date: lcData.last_shipment_date ? new Date(lcData.last_shipment_date) : null,
            lc_open_date: lcData.lc_open_date ? new Date(lcData.lc_open_date) : null,
            lc_amount: lcData.lc_amount || 0,
            margin_percent: lcData.margin_percent || 0,
            margin_amount: lcData.margin_amount || 0,
            currency_id: lcData.currency_id || null,
            supplier_id: lcData.supplier_id || null,
            bank_id: lcData.bank_id || null,
            incoterm_id: lcData.incoterm_id || null,
            payment_term_id: lcData.payment_term_id || null,
            loading_port_id: lcData.loading_port_id || null,
            discharge_port_id: lcData.discharge_port_id || null,
            shipping_method_id: lcData.shipping_method_id || null,
            bank_charge: lcData.bank_charge || 0,
            swift_charge: lcData.swift_charge || 0,
            insurance: lcData.insurance || 0,
            presentation_period: lcData.presentation_period || 21,
            lc_type_id: lcData.lc_type_id || null,
          };

          // Initialize PI item changes
          if (lcData.pis && lcData.pis.length > 0) {
            pi_item_updates.value.value = lcData.pis.map(pi => ({
              pi_id: pi.id, // This is the pi_master_id from the ProformaInvoiceMaster table
              added: [],
              removed: [],
              updated: []
            }));
          }
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load LC data');
      } finally {
        loading.value = false;
      }
    };

    const getPiItemsForAmendment = (pi) => {
      if (!pi || !pi.details) return [];
      // Return the original items directly so v-model works on them
      return pi.details.map(item => {
        // Ensure amount is always calculated and updated on the original item
        const qty = parseFloat(item.qty) || 0;
        const rate = parseFloat(item.rate) || 0;
        const calculatedAmount = qty * rate;
        
        // Update the original item's amount if needed
        if (!item.amount || Math.abs(parseFloat(item.amount) - calculatedAmount) > 0.01) {
          item.amount = calculatedAmount;
        }
        
        // Ensure qty and rate are numbers on the original item
        if (typeof item.qty !== 'number') {
          item.qty = qty;
        }
        if (typeof item.rate !== 'number') {
          item.rate = rate;
        }
        
        // Return the original item reference (not a copy)
        return item;
      });
    };

    const updatePiItem = (piId, item) => {
      // Update the original item's amount immediately for UI reactivity
      const qty = parseFloat(item.qty) || 0;
      const rate = parseFloat(item.rate) || 0;
      item.amount = qty * rate;
      
      const piUpdate = pi_item_updates.value.value.find(p => p.pi_id === piId);
      if (!piUpdate) {
        console.warn('PI update not found for piId:', piId);
        return;
      }

      // If it's a new item, update in added array
      if (item.isNew) {
        // Find the item in added array by reference or by matching properties
        let addedItem = piUpdate.added.find(a => a === item);
        if (!addedItem) {
          // Try to find by product_id if it's a new item without id
          addedItem = piUpdate.added.find(a => !a.id && a.product_id === item.product_id);
        }
        if (addedItem) {
          addedItem.qty = qty;
          addedItem.rate = rate;
          addedItem.amount = qty * rate;
        } else if (item.product_id) {
          // If not found but has product_id, add it
          piUpdate.added.push({
            product_id: item.product_id,
            qty: qty,
            rate: rate,
            amount: qty * rate,
            uom: item.uom || 'PCS',
            hs_code: item.hs_code || null,
          });
        }
        return;
      }

      // For existing items, find or create update entry
      const existingUpdate = piUpdate.updated.find(u => u.id === item.id);
      if (existingUpdate) {
        existingUpdate.qty = qty;
        existingUpdate.rate = rate;
        existingUpdate.amount = qty * rate;
      } else {
        // Find original item to compare
        const originalPi = selectedLcData.value.pis.find(p => p.id === piId || p.pi_master_id === piId);
        const originalItem = originalPi?.details?.find(d => d.id === item.id);
        if (originalItem) {
          const originalQty = parseFloat(originalItem.qty) || 0;
          const originalRate = parseFloat(originalItem.rate) || 0;
          const qtyChanged = Math.abs(originalQty - qty) > 0.01;
          const rateChanged = Math.abs(originalRate - rate) > 0.01;
          
          if (qtyChanged || rateChanged) {
            piUpdate.updated.push({
              id: item.id,
              product_id: item.product_id,
              qty: qty,
              rate: rate,
              amount: qty * rate,
              uom: item.uom,
              hs_code: item.hs_code,
            });
          }
        }
      }
    };

    const selectProductForItem = (piId, item, productId) => {
      // Find product from product map list
      const productMap = getProductMapList.value.find(pm => pm.product_id === productId);
      if (productMap && productMap.product) {
        const product = productMap.product;
        item.product = product;
        item.product_id = productId;
        item.uom = product.unit?.name || 'PCS';
        
        // Auto-populate rate from product's purchase_rate (for import, use purchase rate)
        if (product.purchase_rate) {
          item.rate = parseFloat(product.purchase_rate) || 0;
          // Update amount when rate is set
          item.amount = (parseFloat(item.qty) || 0) * item.rate;
          // Trigger update to save the rate change
          updatePiItem(piId, item);
        }
      }
    };

    const removePiItem = async (piId, item) => {
      const pi = selectedLcData.value.pis.find(p => p.id === piId || p.pi_master_id === piId);
      if (!pi) {
        console.warn('PI not found for piId:', piId);
        return;
      }

      const piUpdate = pi_item_updates.value.value.find(p => p.pi_id === piId);
      if (!piUpdate) {
        console.warn('PI update not found for piId:', piId);
        return;
      }

      // If it's a new item, remove from added and from details
      if (item.isNew) {
        // Remove from added array by reference or by matching properties
        piUpdate.added = piUpdate.added.filter(a => {
          return a !== item && !(a.product_id === item.product_id && !a.id);
        });
        
        // Remove from pi.details
        if (pi.details) {
          const index = pi.details.findIndex(d => {
            return d === item || (d.isNew && d.product_id === item.product_id && !d.id);
          });
          if (index !== -1) {
            pi.details.splice(index, 1);
          }
        }
        await nextTick();
        return;
      }

      // For existing items (have an id)
      if (!item.id) {
        console.warn('Item has no id, cannot remove:', item);
        return;
      }

      // Add to removed array if not already there
      if (!piUpdate.removed.find(r => r.id === item.id)) {
        piUpdate.removed.push({
          id: item.id,
          product_id: item.product_id,
          qty: parseFloat(item.qty) || 0,
          rate: parseFloat(item.rate) || 0,
        });
      }

      // Remove from updated array if it exists there
      piUpdate.updated = piUpdate.updated.filter(u => u.id !== item.id);

      // Remove from UI - find by id in pi.details
      if (pi.details) {
        const index = pi.details.findIndex(d => d.id === item.id);
        if (index !== -1) {
          pi.details.splice(index, 1);
          // Force reactivity update
          await nextTick();
        }
      }
    };

    const addNewPiItem = (piId) => {
      const pi = selectedLcData.value.pis.find(p => p.id === piId);
      if (!pi) return;

      if (!pi.details) {
        pi.details = [];
      }

      const newItem = {
        id: null,
        product_id: null,
        product: null,
        qty: 0,
        rate: 0,
        amount: 0,
        uom: 'PCS',
        hs_code: null,
        isNew: true,
      };

      pi.details.push(newItem);

      const piUpdate = pi_item_updates.value.value.find(p => p.pi_id === piId);
      if (piUpdate) {
        piUpdate.added.push(newItem);
      }
    };

    const loadNewPiDetails = async (piIds) => {
      if (!piIds || piIds.length === 0) {
        newPisDetails.value = [];
        return;
      }

      loadingNewPis.value = true;
      try {
        const detailsPromises = piIds.map(async (piId) => {
          try {
            const piData = await store.dispatch('getLcImportPiById', piId);
            return piData;
          } catch (error) {
            console.error(`Failed to load PI ${piId}:`, error);
            return null;
          }
        });

        const details = await Promise.all(detailsPromises);
        newPisDetails.value = details.filter(pi => pi !== null);
      } catch (error) {
        console.error('Error loading new PI details:', error);
        toast.error('Failed to load PI details');
      } finally {
        loadingNewPis.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      try {
        loading.value = true;

        // Ensure amendment_types is always an array
        let amendmentTypesArray = [];
        if (amendment_types.value.value) {
          if (Array.isArray(amendment_types.value.value)) {
            amendmentTypesArray = amendment_types.value.value;
          } else if (typeof amendment_types.value.value === 'string') {
            // If it's a string, try to parse it or convert to array
            try {
              amendmentTypesArray = JSON.parse(amendment_types.value.value);
            } catch {
              amendmentTypesArray = [amendment_types.value.value];
            }
          }
        }

        // Prepare form data
        const formData = {
          lc_id: lc_id.value.value,
          amendment_no: amendment_no.value.value || '',
          amendment_date: formattedDate(amendment_date.value.value),
          amendment_types: amendmentTypesArray,
          updates: {},
          pi_item_updates: [],
          new_pis: Array.isArray(new_pis.value.value) ? new_pis.value.value : [],
          amendment_charge: parseFloat(amendment_charge.value.value) || 0,
          remarks: remarks.value.value || '',
        };

        // Prepare LC updates (only include changed fields)
        // Backend expects an associative array (object with key-value pairs)
        // Laravel's 'array' validation accepts both [] and {} (associative arrays)
        const currentLc = selectedLcData.value;
        const updatesObj = {};
        if (currentLc && updates.value.value) {
          Object.keys(updates.value.value).forEach(key => {
            const newValue = updates.value.value[key];
            const oldValue = currentLc[key];
            
            if (newValue !== null && newValue !== undefined && newValue !== oldValue) {
              if (newValue instanceof Date) {
                updatesObj[key] = formattedDate(newValue);
              } else {
                updatesObj[key] = newValue;
              }
            }
          });
        }
        // Backend validation requires array type
        // Backend code expects associative array (object with key-value pairs) - see line 152: foreach ($updates as $key => $val)
        // When sent via FormData with JSON.stringify, Laravel will parse it
        // To pass validation, ensure it's always an array type (even if associative)
        // Send empty array when no updates, object when there are updates
        // Laravel's array validation accepts both [] and {} (associative arrays are arrays in PHP)
        formData.updates = Object.keys(updatesObj).length > 0 ? updatesObj : [];

        // Prepare PI item updates (always send as array)
        formData.pi_item_updates = Array.isArray(pi_item_updates.value.value) 
          ? pi_item_updates.value.value
              .map(piUpdate => ({
                pi_id: piUpdate.pi_id, // This is the pi_master_id
                added: Array.isArray(piUpdate.added) ? (piUpdate.added || []).map(item => ({
                  product_id: item.product_id,
                  qty: parseFloat(item.qty) || 0,
                  rate: parseFloat(item.rate) || 0,
                  uom: item.uom || 'PCS',
                  hs_code: item.hs_code || null,
                })) : [],
                removed: Array.isArray(piUpdate.removed) ? (piUpdate.removed || []) : [],
                updated: Array.isArray(piUpdate.updated) ? (piUpdate.updated || []).map(item => ({
                  id: item.id,
                  product_id: item.product_id,
                  qty: parseFloat(item.qty) || 0,
                  rate: parseFloat(item.rate) || 0,
                  uom: item.uom || 'PCS',
                  hs_code: item.hs_code || null,
                })) : [],
              }))
              .filter(pi => 
                (pi.added && pi.added.length > 0) || 
                (pi.removed && pi.removed.length > 0) || 
                (pi.updated && pi.updated.length > 0)
              )
          : [];

        // Add documents
        if (documents.value.value && documents.value.value.length > 0) {
          formData.documents = documents.value.value;
        }

        await store.dispatch('saveUpdateLcImportLcAmendment', formData);
        toast.success('LC Amendment saved successfully');
        router.push({ path: '/lc/import-lc-amendment-record' });
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to save LC Amendment');
      } finally {
        loading.value = false;
      }
    });

    const goBack = () => {
      router.push({ path: '/lc/import-lc-amendment-record' });
    };

    const formatDate = (date) => {
      if (!date) return '';
      return formatDateView(date);
    };

    const formatNumber = (num) => {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num || 0);
    };

    onMounted(async () => {
      try {
        loading.value = true;
        // Load required data - use try-catch for each to prevent one failure from blocking others
        try {
          if (!store.getters.getLcImportLcMasterList || store.getters.getLcImportLcMasterList.length === 0) {
            await store.dispatch('getLcImportLcMasterList');
          }
        } catch (e) {
          console.warn('Failed to load LC Master List:', e);
        }

        try {
          if (!store.getters.getCurrencyList || store.getters.getCurrencyList.length === 0) {
            await store.dispatch('getCurrencyList');
          }
        } catch (e) {
          console.warn('Failed to load Currency List:', e);
        }

        try {
          if (!store.getters.getLcPortList || store.getters.getLcPortList.length === 0) {
            await store.dispatch('getLcPortList');
          }
        } catch (e) {
          console.warn('Failed to load LC Port List:', e);
        }

        try {
          if (!store.getters.getLcTypeList || store.getters.getLcTypeList.length === 0) {
            await store.dispatch('getLcTypeList');
          }
        } catch (e) {
          console.warn('Failed to load LC Type List:', e);
        }

        try {
          if (!store.getters.getSupplierList || store.getters.getSupplierList.length === 0) {
            await store.dispatch('getSupplierList', {});
          }
        } catch (e) {
          console.warn('Failed to load Supplier List:', e);
        }

        try {
          if (!store.getters.getLcBankList || store.getters.getLcBankList.length === 0) {
            await store.dispatch('getLcBankList');
          }
        } catch (e) {
          console.warn('Failed to load LC Bank List:', e);
        }

        try {
          if (!store.getters.getLcIncotermList || store.getters.getLcIncotermList.length === 0) {
            await store.dispatch('getLcIncotermList');
          }
        } catch (e) {
          console.warn('Failed to load LC Incoterm List:', e);
        }

        try {
          if (!store.getters.getLcPaymentTermList || store.getters.getLcPaymentTermList.length === 0) {
            await store.dispatch('getLcPaymentTermList');
          }
        } catch (e) {
          console.warn('Failed to load LC Payment Term List:', e);
        }

        try {
          if (!store.getters.getLcShippingMethodList || store.getters.getLcShippingMethodList.length === 0) {
            await store.dispatch('getLcShippingMethodList');
          }
        } catch (e) {
          console.warn('Failed to load LC Shipping Method List:', e);
        }

        try {
          if (!store.getters.getLcImportPiList || store.getters.getLcImportPiList.length === 0) {
            await store.dispatch('getLcImportPiList');
          }
        } catch (e) {
          console.warn('Failed to load LC Import PI List:', e);
        }

        try {
          if (!store.getters.getProductList || store.getters.getProductList.length === 0) {
            // getProductList requires POST data
            await store.dispatch('getProductList', {});
          }
        } catch (e) {
          console.warn('Failed to load Product List:', e);
        }

        try {
          if (!store.getters.getProductMapList || store.getters.getProductMapList.length === 0) {
            await store.dispatch('getProductMapList', {});
          }
        } catch (e) {
          console.warn('Failed to load Product Map List:', e);
        }

        // Check if editing
        if (route.params.id) {
          isEditMode.value = true;
          // Load amendment data for editing
          // This would be implemented if edit functionality is needed
        }
      } catch (error) {
        console.error('Error in onMounted:', error);
        toast.error('Failed to initialize page. Please refresh.');
      } finally {
        loading.value = false;
      }
    });

    return {
      panel,
      panel1,
      panel2,
      panel3,
      loading,
      selectedLcData,
      isEditMode,
      newPisDetails,
      loadingNewPis,
      lc_id,
      amendment_no,
      amendment_date,
      amendment_types,
      amendment_charge,
      remarks,
      documents,
      updates,
      pi_item_updates,
      new_pis,
      getLcImportLcMasterList,
      getLcImportPiList,
      getAvailablePiList,
      getCurrencyList,
      getLcPortList,
      getLcTypeList,
      getSupplierList,
      getLcBankList,
      getLcIncotermList,
      getLcPaymentTermList,
      getLcShippingMethodList,
      getProductList,
      getProductMapList,
      getMappedProductsForPi,
      amendmentTypeOptions,
      piItemHeaders,
      loadLcData,
      getPiItemsForAmendment,
      updatePiItem,
      removePiItem,
      addNewPiItem,
      selectProductForItem,
      loadNewPiDetails,
      submit,
      goBack,
      formatDate,
      formatNumber,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>



